import PropTypes, { bool } from 'prop-types';

export default function Avatar({ openModal = () => {}, img = '', canChangeAvatar = false }) {
	const classes = ['blog-feedback__avatar'];
	if (canChangeAvatar) {
		classes.push('blog-feedback__avatar--edit');
	}

	return (
		<div onClick={() => canChangeAvatar && openModal()} className={classes.join(' ')}>
			<img src={img} alt="" loading="lazy" />
		</div>
	);
}

Avatar.propTypes = {
	openModal: PropTypes.func,
	img: PropTypes.string,
	canChangeAvatar: bool,
};
